import axiosInstance from "../../api/axiosInstance";

export const fetchRegionsAPI = async () => {
  const regionsList = await axiosInstance.get("regions/get-all-regions");

  return regionsList.data;
};

export const createRegionAPI = async (regionData) => {
  const newRegion = await axiosInstance.post(
    "regions/create-region",
    regionData
  );

  return newRegion.data;
};

export const deleteRegionAPI = async (id) => {
  const deletedRegion = await axiosInstance.delete(
    `regions/delete-region/${id}`
  );

  return deletedRegion.data;
};

export const updateRegionAPI = async (id, regionData) => {
  const updatedRegion = await axiosInstance.put(
    `regions/update-region/${id}`,
    regionData
  );

  return updatedRegion.data;
};
